export default {"src":"/_next/static/media/credit-card-front-regular.b32d5fbe.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};